import { Alert, Color } from '@isbj-redesign/frontend-components'
import { JWTAuthProvider, useAuth } from '@nortal/frontend-auth'
import React, { FC } from 'react'
import { useHistory } from 'react-router'

const { anmeldungUrl } = window.isbj.env || {}

export const AuthProvider: FC = ({ children }) => (
    <JWTAuthProvider tokenName="auth">
        <Main>{children}</Main>
    </JWTAuthProvider>
)

export const useLoginRedirect = () => () => {
    const returnUrl = `${location.origin}/_authorize`
    location.assign(`${anmeldungUrl}/?r=${encodeURIComponent(returnUrl)}&v=2`)
}

const Main: FC = ({ children }) => {
    const auth = useAuth()
    const { location: loc } = useHistory()
    const redirectToLogin = useLoginRedirect()

    //browsercheck should be visible to everyone
    if (loc.pathname === '/browsercheck') return <>{children}</>

    if (auth.state === 'pending') return null

    if (auth.state === 'anonymous') {
        redirectToLogin()
        return (
            <main className="p-4">
                <Alert color={Color.Info}>Sie werden zur Anmeldung weitergeleitet&hellip;</Alert>
            </main>
        )
    }

    return <>{children}</>
}
